import type { TFilterType, TGroupingType, TSortingType } from '@repo/well-list';
import { action, computed, makeObservable, observable } from 'mobx';

export type TWellListState = {
  filterBy?: TFilterType;
  groupBy?: TGroupingType;
  searchValue?: string;
  selectedWellId?: number;
  activeKeys?: string[];
  sorting?: TSortingType;
  groupId?: string;
  isPinned?: boolean;
};

export class WellListPanelState {
  @observable private wellListPanelState: TWellListState | null;

  constructor(initialState: TWellListState | null) {
    this.wellListPanelState = initialState;

    makeObservable(this);
  }

  @action.bound
  updateWellListPanelState(data: Partial<TWellListState> | null): void {
    if (!data) {
      this.wellListPanelState = null;
      return;
    }

    this.wellListPanelState = { ...this.wellListPanelState, ...data };
  }

  @computed
  get data(): TWellListState | null {
    return this.wellListPanelState;
  }

  @computed
  get filterBy(): TFilterType | undefined {
    return this.wellListPanelState?.filterBy;
  }

  @computed
  get groupBy(): TGroupingType | undefined {
    return this.wellListPanelState?.groupBy;
  }

  @computed
  get searchValue(): string | undefined {
    return this.wellListPanelState?.searchValue;
  }

  @computed
  get selectedWellId(): number | undefined {
    return this.wellListPanelState?.selectedWellId ?? undefined;
  }

  @computed
  get activeKeys(): string[] | undefined {
    return this.wellListPanelState?.activeKeys;
  }

  @computed
  get sorting(): TSortingType | undefined {
    return this.wellListPanelState?.sorting;
  }

  @computed
  get groupId(): string | undefined {
    return this.wellListPanelState?.groupId;
  }

  @computed
  get isPinned(): boolean {
    return this.wellListPanelState?.isPinned ?? false;
  }
}
